import { render } from "./ProfileActivities.vue?vue&type=template&id=68dbf9c4&scoped=true"
import script from "./ProfileActivities.vue?vue&type=script&lang=js"
export * from "./ProfileActivities.vue?vue&type=script&lang=js"

import "./ProfileActivities.vue?vue&type=style&index=0&id=68dbf9c4&scoped=true&lang=css"

import exportComponent from "/Users/mac/Desktop/projNii/ERP/rada-erp-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68dbf9c4"]])

export default __exports__